
import { addDays, isBefore, isAfter } from 'date-fns';

/**
 * Calculates the minimum allowed date (1 week from today)
 */
export function getMinInstallationDate(): Date {
  return addDays(new Date(), 7);
}

/**
 * Calculates the maximum allowed date (2 months from today)
 */
export function getMaxInstallationDate(): Date {
  return addDays(new Date(), 60);
}

/**
 * Determines if a date should be disabled for selection
 */
export function isDateDisabled(date: Date): boolean {
  const minDate = getMinInstallationDate();
  const maxDate = getMaxInstallationDate();
  
  // Disable dates before min date
  if (isBefore(date, minDate)) {
    return true;
  }
  
  // Disable dates after max date
  if (isAfter(date, maxDate)) {
    return true;
  }
  
  // Disable weekends (Saturday = 6, Sunday = 0)
  const day = date.getDay();
  if (day === 0 || day === 6) {
    return true;
  }
  
  return false;
}
